/* =============================================
   SHOP MODULE — JS
   Filtering, Cart (localStorage), Drawer
   WooCommerce-ready stub
   ============================================= */
(function () {
    'use strict';

    var STORAGE_KEY = 'iqone_cart_v1';

    /* ===== CART ===== */
    function getCart() {
        try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; } catch (e) { return []; }
    }
    function saveCart(cart) {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(cart));
        renderCart();
        updateCartCount();
    }
    function addToCart(item) {
        var cart = getCart();
        var existing = cart.find(function (it) { return it.id === item.id && it.size === item.size && it.color === item.color; });
        if (existing) { existing.qty += (item.qty || 1); }
        else { cart.push(Object.assign({ qty: 1 }, item)); }
        saveCart(cart);
        openCart();
    }
    function removeFromCart(idx) {
        var cart = getCart();
        cart.splice(idx, 1);
        saveCart(cart);
    }
    function cartTotal() {
        return getCart().reduce(function (sum, it) { return sum + it.price * it.qty; }, 0);
    }
    function fmtPLN(n) { return n.toLocaleString('pl-PL') + ' PLN'; }

    function renderCart() {
        var box = document.getElementById('cart-items');
        var total = document.getElementById('cart-total');
        if (!box || !total) return;
        var cart = getCart();
        if (!cart.length) {
            box.innerHTML = '<div class="cart-empty">Twój koszyk jest pusty.</div>';
        } else {
            box.innerHTML = cart.map(function (it, i) {
                var meta = [it.variant, it.size, it.qty > 1 ? 'x' + it.qty : ''].filter(Boolean).join(' · ');
                var imgHtml = it.image ? '<img src="' + it.image + '" alt="' + it.name + '">' : '';
                return ''
                    + '<div class="cart-line">'
                    +   '<div class="cart-line-img">' + imgHtml + '</div>'
                    +   '<div><div class="cart-line-name">' + it.name + '</div><div class="cart-line-meta">' + meta + '</div></div>'
                    +   '<div style="text-align:right"><div class="cart-line-price">' + fmtPLN(it.price * it.qty) + '</div><button class="cart-line-rm" data-rm="' + i + '">&#10005;</button></div>'
                    + '</div>';
            }).join('');
        }
        total.textContent = fmtPLN(cartTotal());
    }

    function updateCartCount() {
        var el = document.getElementById('cart-count');
        if (!el) return;
        var n = getCart().reduce(function (s, it) { return s + it.qty; }, 0);
        el.textContent = n;
        el.style.display = n > 0 ? 'flex' : 'none';
    }

    /* ===== DRAWER ===== */
    function openCart() {
        var d = document.getElementById('cart-drawer');
        var o = document.getElementById('cart-overlay');
        if (d) d.classList.add('open');
        if (o) o.classList.add('open');
    }
    function closeCart() {
        var d = document.getElementById('cart-drawer');
        var o = document.getElementById('cart-overlay');
        if (d) d.classList.remove('open');
        if (o) o.classList.remove('open');
    }

    /* ===== FILTERING ===== */
    function setupFilters() {
        var buttons = document.querySelectorAll('.shop-filter');
        var cards = document.querySelectorAll('.shop-card[data-type]');
        var countEl = document.getElementById('result-count');

        buttons.forEach(function (btn) {
            btn.addEventListener('click', function () {
                buttons.forEach(function (b) { b.classList.remove('active'); });
                btn.classList.add('active');
                var filter = btn.getAttribute('data-filter');
                var visible = 0;
                cards.forEach(function (card) {
                    var types = card.getAttribute('data-type') || '';
                    var show = (filter === 'all' || types.indexOf(filter) !== -1);
                    card.style.display = show ? '' : 'none';
                    if (show) visible++;
                });
                if (countEl) countEl.textContent = visible;
            });
        });
    }

    /* ===== LOWEST PRICE 30 DAYS ===== */
    function setupLowestPrice() {
        // Price history per product (id -> array of {price, date})
        // In production this would come from a database/API
        // For now, lowest = current price (no discounts yet)
        var priceRows = document.querySelectorAll('.shop-card-price-row[data-lowest-30]');
        priceRows.forEach(function(row) {
            var priceEl = row.querySelector('.shop-card-price');
            if (!priceEl) return;
            var currentPrice = parseInt(priceEl.textContent);
            var lowest = row.getAttribute('data-lowest-30');
            var lowestPrice = lowest ? parseInt(lowest) : currentPrice;
            if (!lowest || lowestPrice > currentPrice) lowestPrice = currentPrice;

            var existing = row.querySelector('.shop-card-lowest');
            if (!existing) {
                var span = document.createElement('span');
                span.className = 'shop-card-lowest';
                span.textContent = 'Najniższa cena z 30 dni: ' + lowestPrice + ' PLN';
                row.parentElement.insertBefore(span, row.nextSibling);
            }
        });
    }

    /* ===== INIT ===== */
    document.addEventListener('DOMContentLoaded', function () {
        renderCart();
        updateCartCount();
        setupFilters();
        setupLowestPrice();

        // Quickadd & remove
        document.addEventListener('click', function (e) {
            var qa = e.target.closest('[data-quickadd]');
            if (qa) {
                e.preventDefault();
                e.stopPropagation();
                var data = JSON.parse(qa.getAttribute('data-quickadd'));
                addToCart(data);
                return;
            }
            var rm = e.target.closest('[data-rm]');
            if (rm) { removeFromCart(parseInt(rm.getAttribute('data-rm'), 10)); return; }
        });

        // Cart drawer
        var cartBtn = document.getElementById('cart-btn');
        if (cartBtn) cartBtn.addEventListener('click', openCart);
        var cartClose = document.getElementById('cart-close');
        if (cartClose) cartClose.addEventListener('click', closeCart);
        var overlay = document.getElementById('cart-overlay');
        if (overlay) overlay.addEventListener('click', closeCart);
    });

    // Expose for product.js
    window.IQShop = { addToCart: addToCart, openCart: openCart, getCart: getCart, fmtPLN: fmtPLN };
})();
